/**  activity actions constants */
export const SET_LIST_ACTIVITY = 'activity/SET_LIST_ACTIVITY';